<template>
  <div class="oiq-create-form" v-if="formInfo" v-loading="loading || formLoading">
    <div class="tfs-step-tips" v-if="step === 2">
      <span v-if="step1Form.destinationObj.ladingBillType === 'draftOfBL'">申请预开号，请补充以下信息，若已上传申报所需文件，可跳过必填内容直接提交。</span>
      <span v-else>
        {{step1Form.destinationObj.trackingNo ? `您的跟踪单号为：${step1Form.destinationObj.trackingNo}，` : ''}}
        <template v-if="!step1Form.destinationObj.billOfLading.length">
          请返回
          <span style="cursor: pointer" @click="prev">上一步</span>
          提供正式提单文件，上传后可跳过必填内容直接提交。
        </template>
        <template v-else>申请正式单号，请补充以下信息，若已上传申报所需文件，可跳过必填内容直接提交。</template>
      </span>
    </div>
    <ApplyMenus :menus="components" v-if="hasMenus" />
      <div class="step1-component" v-show="step === 1 || isDetail">
        <component v-for="component in step1Components"
                   :moduleData="component"
                   :key="component.ref"
                   :is="component.name"
                   :ref="component.ref"
                   :commonProps="commonProps"
                   v-bind.sync="commonProps"
                   v-on="bindObj"
                   v-model="component.value"
                   :applyInfoData.sync="applyInfoData"
                   :invoiceData.sync="invoiceData"
                   :reportLuaCode.sync="reportLuaCode"
                   :formConfig="step1FormConfig"
                   :originalCountry.sync="originalCountry"
        ></component>
      </div>
      <div class="step2-component" v-show="step === 2 || isDetail">
        <component v-for="component in step2Components"
                   :moduleData="component"
                   :key="component.ref"
                   :is="component.name"
                   :ref="component.ref"
                   :commonProps="commonProps"
                   v-bind.sync="commonProps"
                   v-on="bindObj"
                   v-model="component.value"
                   :applyInfoData.sync="applyInfoData"
                   :invoiceData.sync="invoiceData"
                   :reportLuaCode.sync="reportLuaCode"
                   :formConfig="step2FormConfig"
        ></component>
    </div>
    <div class="apply-notice" v-if="submitTip" v-html="submitTip"></div>
    <template v-if="!disabledAll">
      <div class="btns" v-if="!isCs">
        <template v-if="formInfo.orderBase && formInfo.orderBase.state !== 11 && isEdit">
          <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="hasNext && step === 1">下一步</el-button>
          <el-button type="primary" @click="prev" :disabled="disabledAll" v-if="step === 2">返回上一步</el-button>
          <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="!hasNext || step === 2">提交修改申请表</el-button>
        </template>
        <template v-else>
          <el-button @click="handleSubmit(false)" class="staging-btn" :disabled="disabledAll">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="hasNext && step === 1">下一步</el-button>
          <el-button type="primary" @click="prev" :disabled="disabledAll" v-if="step === 2">返回上一步</el-button>
          <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="!hasNext || step === 2">提交申请表</el-button>
        </template>
      </div>
      <div class="btns" v-else>
        <el-button @click="handleSubmit(false)" class="staging-btn" :disabled="disabledAll" v-if="isCreate || formInfo.orderBase.state === 11">保存草稿</el-button>
        <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="hasNext && step === 1">下一步</el-button>
        <el-button type="primary" @click="prev" :disabled="disabledAll" v-if="step === 2">返回上一步</el-button>
        <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll" v-if="(!hasNext || step === 2) && canSubmit">提交申请表</el-button>
        <el-button type="primary" @click="copyUrl" :disabled="disabledAll" v-if="!isCreate && formInfo.orderBase.state === 11 && !isOiq">复制链接</el-button>
      </div>
    </template>
    <div class="notice" v-if="!isCs && !disabledAll">
      <el-checkbox v-model="checkNotice" v-if="isLogin">
        提交申请表即视为接受<a class="redColor" href="https://cmsuat.sgsonline.com.cn/overview/terms-and-conditions" target="_blank">《SGS服务通用条款》</a>
      </el-checkbox>
      <el-checkbox v-model="checkRegister" v-else>
        <span class="text">阅读并同意<em class="activeColr" @click="setTipsVisible(true)">注册</em></span>及<a class="activeColr"
                                                                                                               href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs" target="_blank">隐私条款</a>，提交申请表即视为接受<a class="redColor" href="https://cmsuat.sgsonline.com.cn/overview/terms-and-conditions" target="_blank">《SGS服务通用条款》</a>
      </el-checkbox>
    </div>
    <register-terms v-if="tipsVisible" @setTipsVisible="setTipsVisible"></register-terms>
    <login-verify-code :env="env" :captchaAppId="'192302431'" v-model="codeShow" :number="formData.application ? formData.application.linkPhone : ''" :data="codeData" @loginSuccess="codeSuccess"/>
  </div>
</template>

<script>
import ApplyMenus from "./components/ApplyMenus.vue";
import ApplyInfo from "./components/ApplyInfo.vue";
import PayInfo from "src/components/application/components/PayInfo.vue";
import ReportInfo from "src/components/application/components/ReportInfo.vue";
import Sample from "src/components/application/components/Sample.vue";
import TestInfo from "src/components/application/components/TestInfo.vue";
import ServiceInfo from "src/components/application/components/ServiceInfo.vue";
import RemindInfo from "src/components/application/components/RemindInfo.vue";
import {getParam, typeOf, getTreeList} from "utils";
import {getEnumBatch} from "src/request/apis";
import {host} from "src/config";
import RegisterTerms from "src/components/loginMerge/RegisterTerms.vue";
import LoginVerifyCode from "src/components/loginVerifyCode/index.vue";
import DestinationDocument from "src/components/application/components/DestinationDocument.vue";
import TFSCommonForm from "src/components/application/components/TFSCommonForm.vue";
import TFSTransport from "src/components/application/components/TFSTransport.vue";

export default {
  name: "TicApplication",
  components: {
    ApplyMenus,
    ApplyInfo,
    PayInfo,
    ReportInfo,
    Sample,
    TestInfo,
    ServiceInfo,
    RemindInfo,
    RegisterTerms,
    LoginVerifyCode,
    DestinationDocument,
    TFSCommonForm,
    TFSTransport
  },
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    notShare: {
      type: Boolean,
      default: true
    },
    isCs: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    hasUser: {
      type: Boolean,
      default: false
    },
    env: {
      type: String,
      default: 'local'
    },
    bu: {
      type: String,
      default: ''
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    formInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    csInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    invoiceFileList: {
      type: Array,
      default() {
        return []
      }
    },
    isOiq: {
      type: Boolean,
      default: false
    },
    buName: {
      type: String,
      default: ''
    },
    businessObj: {
      type: Object,
      default: null
    },
    top: {
      type: Number,
      default: 278
    },
    canSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeData: {
        title: '验证手机号',
        sendModel: '已发送到申请方手机号：+86',
        prepend: '手机验证码'
      },
      components: [],
      step1Components: [],
      step2Components: [],
      isSave: false,
      reportLuaCode: '',
      invoiceData: {},
      applyInfoData: {},
      enumConfig: null,
      host: host(this.env),
      businessCode: '',
      businessInfo: null,
      isEdit: false,
      checkNotice: false,
      checkRegister: false,
      tipsVisible: false,
      formData: {},
      codeShow: false,
      sampleCategoryByCode: {},
      configById: {},
      step: 1,
      step1Form: {
        // todo 删除
        destinationObj: {
          "ladingBillType": "applyACINo",
          "destinationCountry": "draftOfBL",
          "trackingNo": "3333",
          "draftOfBL": [
            {
              "src": "https://publicfilesuat.sgsonline.com.cn/TIC/2024/12/999912-3_1734917441163.jpg",
              "name": "999912-3.jpg"
            }
          ],
          "billOfLading": [
            {
              "name": "chat.png",
              "src": "https://publicfilesuat.sgsonline.com.cn/TIC/2024/12/chat_1734919295911.png"
            }
          ],
          "commercialInvoice": [
            {
              "src": "https://publicfilesuat.sgsonline.com.cn/TIC/2024/12/999912-2_1734917444668.png",
              "name": "999912-2.png"
            }
          ],
          "packingList": [
            {
              "src": "https://publicfilesuat.sgsonline.com.cn/TIC/2024/12/999912-1_1734917448527.jpg",
              "name": "999912-1.jpg"
            }
          ]
        }
      },
      step2Form: {},
      loading: false,
      formLoading: false,
      step1FormConfig: [],
      step2FormConfig: [],
      hasMenus: false,
      originalCountry: '',
      isCountryChange: false,
      submitTip: ''
    }
  },
  computed: {
    bindObj() {
      return {
        delAddress: this.delAddress,
        loginEmit: this.loginEmit,
        sampleCategoryChange: this.sampleCategoryChange
      }
    },
    commonProps() {
      return {
        formInfo: this.formInfo,
        linkDisabled: this.linkDisabled,
        env: this.env,
        apis: this.apis,
        orderNo: this.orderNo,
        isCs: this.isCs,
        isLogin: this.isLogin,
        disabledAll: this.disabledAll,
        isOiq: this.isOiq,
        isSave: this.isSave,
        bu: this.bu,
        isCreate: this.isCreate,
        userInfo: this.userInfo,
        notShare: this.notShare,
        hasUser: this.hasUser,
        orderDetail: this.orderDetail,
        csInfo: this.csInfo,
        invoiceFileList: this.invoiceFileList,
        emailRequired: false,
        buName: this.buName,
        enumConfig: this.enumConfig,
        businessInfo: this.businessInfo,
        top: this.top,
        sampleCategoryByCode: this.sampleCategoryByCode,
        step1Form: this.step1Form,
        isCountryChange: this.isCountryChange
      }
    },
    linkDisabled() {
      return !this.isCreate && ((!this.isCs && !this.isOiq && !this.isLogin) || this.isCs)
    },
    isCreate() {
      return (!this.orderNo || this.isAgain) && !this.isOiq
    },
    hasNext() {
      return this.bu === '2700'
    },
  },
  watch: {
    businessObj: {
      handler(val) {
        if (val) this.businessInfo = val
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (this.isDetail && this.hasNext && val.destinationList && val.destinationList.length) {
          const destinationCountry = val.destinationList.find(v => v.attrCode === 'destinationCountry') || {}
          const country =  destinationCountry.attrValue
          if (country) {
            this.qryPageConfig(country, 2)
            this.qryFormConfig(country, 2)
          }
        }
      },
      immediate: true
    },
    step1FormConfig: {
      handler(val) {
        if (!val.length) return
      },
      immediate: true
    },
  },
  created() {
    const query = this.$route.query
    this.orderNo = query.orderNo
    this.isAgain = !!query.isAgain
    this.isEdit = !!this.$route.query.isEdit
    if (!this.isCs) this.qryBusiness()
    // this.getBasic()
    this.qryPageConfig(this.bu, 1)
    this.qryFormConfig(this.bu, 1)
    // this.qryPageConfig('BURKINA_FASO', 1)
    // this.qryFormConfig('BURKINA_FASO', 1)
  },
  methods: {
    getFormConfigByCode(list) {
      const obj = {}
      list.forEach(v => {
        if (!v.showAttr) v.showAttr = {}
        obj[v.attrCode] = v
      })
      return obj
    },
    qryPageConfig(formType, step) {
      this.loading = true
      return this.apis.qryPagesByBu({
        pageLocation: 'APPLICATION',
        formType
      }).then(res => {
        this.loading = false
        const data = getTreeList(res.data.pageConfigs[0].pageFloors.find(v => v.floorCode === 'Application').items, 'isEndKey', 'itemId', 'parentId')
        // itemType 1 为唯一组件，3为多个组件 其他不是组件
        const components = data.list.filter(v => {
          if (v.itemCode === 'ApplyMenus') this.hasMenus = true
          if (v.itemCode === 'SubmitTip') this.submitTip = v.itemDesc
          return v.itemType === 1 || v.itemType === 3
        })
        this.configById = data.listById
        components.forEach(v => {
          v.name = v.componentName
          v.ref = v.itemType === 1 ? v.name : v.itemCode
          const mappingJson = v.mappingExtend || {}
          v.sourceFormatJson = mappingJson.sourceFormatJson || []
          v.getFormatJson = mappingJson.getFormatJson || []
          v.value = {}
        })
        this.components = components
        const key = step === 1 ? 'step1Components' : 'step2Components'
        this[key] = components
        return Promise.resolve(true)
      }).catch(e => {
        this.loading = false
        console.log(e);
        return Promise.resolve(false)
      })
    },
    qryFormConfig(businessCode, step) {
      this.formLoading = true
      return this.apis.qryBasicMsds({
        businessType: 'OIQ',
        businessCode
      }).then(res => {
        this.formLoading = false
        if (step === 1) {
          const val = res.data.items
          const sampleConfigObj = val.find(v => v.areaCode === 'Sample') || {}
          const sampleCategory = this.getFormConfigByCode(sampleConfigObj.attrs || []).sampleCategory
          if (sampleCategory && sampleCategory.enums) {
            const sampleCategoryData  = this.getEnumTree(sampleCategory.enums)
            sampleCategory.enums = sampleCategoryData.arr
            this.sampleCategoryByCode = sampleCategoryData.enumsByCode
          }
          this.step1FormConfig = res.data.items
        } else {
          this.step2FormConfig = res.data.items
        }
        return Promise.resolve(true)
      }).catch(e => {
        this.formLoading = false
        console.log(e);
        return Promise.resolve(false)
      })
    },
    setTipsVisible(val) {
      this.tipsVisible = val
    },
    copyUrl() {
      this.$emit('copyUrl', this.orderNo)
    },
    sampleCategoryChange(data) {
      this.$refs.TestInfo[0] && this.$refs.TestInfo[0].reset(data)
    },
    qryBusiness() {
      const query = this.$route.query
      this.businessCode = this.formInfo.orderBase ? this.formInfo.orderBase.businessCode : ''
      const bl = getParam(query, 'bl')
      if (this.isCreate && !this.isAgain && bl) this.businessCode = decodeURIComponent(bl).toUpperCase()
      this.apis.qryLineByLineCode({
        bu: this.bu,
        lineCode: this.businessCode
      }).then(res => {
        this.businessInfo = res.data
      }).catch(e => {
        console.log(e);
      })
    },
    getBasic() {
      this.loading = true
      const buInfo = this.buName ? this.buName.toUpperCase() + '_' : ''
      getEnumBatch([
        // 报告语言
        {
          tableName: 'ORDER_BASE_INFO',
          colName: `${buInfo}REPORT_LUA`,
        },
        // 报告形式
        {
          tableName: 'ORDER_BASE_INFO',
          colName: `${buInfo}REPORT_FORM`,
        },
        // 报告出具要求
        {
          tableName: 'ORDER_REPORT',
          colName: `${buInfo}REPORT_METHOD`,
        },
        // 周期要求
        {
          tableName: 'ORDER_BASE_INFO',
          colName: `${buInfo}TEST_CYCLE`,
        },
        // 盖资质章
        {
          tableName: 'APPLICATION_FORM',
          colName: 'LAB_QUALIFICATION',
        },
        // 样品类型
        {
          tableName: 'ORDER_SAMPLE',
          colName: `${buInfo}SAMPLE_CATEGORY`,
        },
        // 样品状态
        {
          tableName: 'ORDER_SAMPLE',
          colName: `${buInfo}SAMPLE_SHAPE`,
        },
        // 测试标准
        // {
        //   tableName: 'ORDER_BASE_INFO',
        //   colName: `${buInfo}STANDARD_MODEL`,
        // },
      ], this.host.javaUrl).then(res => {
        this.loading = false
        if (res.resultCode === '0') {
          const sampleCategoryData  = this.getEnumTree(res.data[`ORDER_SAMPLE.${buInfo}SAMPLE_CATEGORY`])
          res.data[`ORDER_SAMPLE.${buInfo}SAMPLE_CATEGORY`] = sampleCategoryData.arr
          this.sampleCategoryByCode = sampleCategoryData.enumsByCode
          this.enumConfig = res.data
        } else {
          this.$message.error(res.resultMsg)
        }
      }).catch(e => {
        this.loading = false
      })
    },
    getEnumTree(enums) {
      const enumsByCode = {}
      const arr = enums.filter(v => {
        if (!v.children) v.children = []
        enumsByCode[v.enumCode] = v
        return !v.parentEnumCode
      })
      enums.forEach(v => {
        if (v.parentEnumCode) enumsByCode[v.parentEnumCode].children.push(v)
      })
      return {
        arr,
        enumsByCode
      }
    },
    loginEmit() {
      this.$emit('loginEmit')
    },
    delAddress(addressId) {
      // todo 删除地址库地址
      const keys = ['backAddressData', 'reportAddressData']
      keys.forEach(v => {
        this.components.forEach((v, index) => {
          const name = v.itemType === 1 ? v.name : v.itemCode
          const ref = this.$refs[name] && this.$refs[name][0]
          if (ref[v]) {
            ref[v] = ref[v].filter(v => this[v].addressId !== addressId)
          }
        })
      })
    },
    getApplyData() {
      const data = this.getFormValidateArr(true, )
      console.log(data);
      // const data = this.getFormValidateArr(true, ['ApplyInfo'])
      return {
        linkPerson: data.application.linkPerson,
        linkEmail: data.application.linkEmail,
        linkPhone: data.application.linkPhone,
      }
    },
    mergeObjects(target, ...sources) {
      sources.forEach(source => {
        Object.keys(source).forEach(key => {
          if (typeOf(source[key]) === 'object') {
            if (!target[key]) {
              Object.assign(target, { [key]: {} });
            }
            this.mergeObjects(target[key], source[key]);
          } else {
            Object.assign(target, { [key]: source[key] });
          }
        });
      });
    },
    getFormValidateArr(isGetData, key, isCache) {
      let arr = []
      let data = {}
      this.components.forEach((v, index) => {
        if (!key || key.includes(v.name)) {
          const name = v.itemType === 1 ? v.name : v.itemCode
          const ref = this.$refs[name] && this.$refs[name][0]
          if (ref && ref.getValidate) arr = arr.concat(ref.getValidate(isCache))
          if (v.value) this.mergeObjects(data, v.value)
          v.children && v.children.forEach(child => {
            if (child.value) this.mergeObjects(data, child.value)
          })
        }
      })
      this.formData = data
      console.log(data);
      this.formData.type = this.isSave ? 1 : 0
      this.formData.orderNo = this.isCreate ? '' : this.orderNo
      // if (!this.formData.orderBase) this.formData.orderBase = {}
      if (this.step === 1)this.formData.orderBase.bu = this.bu
      if (this.step === 1) {
        this.step1Form = JSON.parse(JSON.stringify(this.formData))
      } else {
        this.step2Form = JSON.parse(JSON.stringify(this.formData))
      }
      if (isGetData) return data
      console.log(arr);
      return arr
    },
    prev() {
      Promise.all(this.getFormValidateArr()).then(res => {
        this.step = 1
        this.components = this.step1Components
      }).then()
    },
    handleSubmit(isSave) {
      this.isSave = isSave
      const ApplyInfo = this.$refs.ApplyInfo
      if (ApplyInfo) ApplyInfo[0].changeSpecExpand(true)
      this.$nextTick(() => {
        let text = '请填写必填项'
        Promise.all(this.getFormValidateArr()).then(res => {
          console.log(res);
          if (res.every(v => {
            if (typeof v === 'boolean' && v) {
              return true
            } else if (typeof v === 'string') {
              text = v
            }
          })) {
            if (this.hasNext && this.step === 1 && isSave) {
              this.step1Form = JSON.parse(JSON.stringify(this.formData))
              const destinationCountry = this.formData.destinationObj.destinationCountry
              this.isCountryChange = destinationCountry !== this.originalCountry
              if (this.destinationCountry === destinationCountry) {
                this.step = 2
                this.components = this.step2Components
                return
              }
              this.destinationCountry = destinationCountry
              Promise.all([this.qryPageConfig(destinationCountry, 2), this.qryFormConfig(destinationCountry, 2)]).then(res => {
                if (res.map(v => v)) this.step = 2
              })
              return
            }
            if (!this.isCs && !this.checkNotice && isSave && this.isLogin) {
              this.$message.error('请接受 SGS服务通用条款')
              return
            }
            this.formData = Object.assign(this.step1Form, this.step2Form)
            delete this.formData.formAttrFlg
            if (this.hasNext && this.step === 1) this.formData.formAttrFlg = 1
            // this.formData = Object.assign(JSON.parse(JSON.stringify(this.formInfo)), this.step1Form, this.step2Form)
            this.saveForm(this.formData)
          } else {
            this.$message.error(text)
            setTimeout(() => {
              var isError = document.getElementsByClassName("el-form-item is-error");//此处的xunjia为自定义的类名称，可根据项目实际写或者不写
              var iserrortop = isError[0].getBoundingClientRect().top
              window.scrollTo(0, document.body.scrollTop + iserrortop)
            }, 100);
          }
        }).then(e => {
          this.isSave = false
        })
      })
    },
    saveForm(data) {
      if (this.isCs || this.isLogin) {
        this.$emit('saveForm', data)
        return
      }
      if (!this.checkRegister) {
        this.loading = false
        this.$alert('同意注册条款和隐藏协议后才可以继续提交', '', { confirmButtonText: '确定', center: true });
        return
      }
      this.showLoginCode()
    },
    showLoginCode() {
      this.codeShow = true
    },
    codeSuccess() {
      this.$emit('loginEmit')
      this.$emit('saveForm', this.formData)
    },
  }
}
</script>

<style lang="scss">
.oiq-create-form {
  width: 100%;
  max-width: 1226px;
  position: relative;
  .apply-notice {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .tfs-step-tips {
    background: rgba(255, 102, 0, 0.08);
    text-align: center;
    color: rgb(202, 67, 0);
    font-size: 14px;
    line-height: 18px;
    min-height: 40px;
    margin-bottom: 20px;
    padding: 11px 20px;
  }
  .form-bottom-tips {
    position: absolute;
    bottom: -20px;
    left: 0;
    color: rgb(255, 48, 48);
    font-size: 14px;
    line-height: 14px;
  }
  .buyer-tips {
    padding-left: 165px;
    color: rgb(255, 60, 60);
    font-size: 12px;
    line-height: 16px;
    position: relative;
    top: -13px;
  }
  .copy-btn {
    width: 142px;
    height: 36px;
    border: 1px solid rgb(202, 67, 0);
    border-radius: 4px;
    background: rgba(255, 102, 0, 0.05);
    color: rgb(202, 67, 0);
    margin-left: 15px;
    position: relative;
    top: 2px;
  }
  .yangpin-tab {
    height: 22px;
    background: #f6f6f6;
    border: 1px solid #dcdcdc;
    border-radius: 3px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #878787;
    text-align: center;
    line-height: 20px;
    max-width: 202px;
    padding: 0 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    p {
      line-height: 20px;
    }
  }
  .give-away-icon {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: rgba(254, 102, 2, 1);
    border-radius: 50%;
    font-size: 14px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 23px;
    margin-left: 10px;
    text-align: center;
  }
  .invoice-content {
    padding-top: 5px;
  }
  .report-form {
    width: 870px;
    border-radius: 4px;
    background: rgb(245, 245, 245);
    display: flex;
    flex-wrap: wrap;
    padding: 17px 0 0 26px;
    margin-bottom: 20px;
    .report-form-item {
      margin-right: 45px;
      .label {
        color: rgb(153, 153, 153);
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 9px;
      }
      .content {
        width: 360px;
        margin-bottom: 15px;
        color: rgb(51, 51, 51);
        font-size: 14px;
        line-height: 20px;
        min-height: 20px;
      }
    }
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-input {
      width: 360px;
    }
  }
  .fixed-tab {
    position: fixed;
    width: 1226px;
    background: black;
    left: 0;
    right: 0;
    margin: auto;
    //top: calc(50vh - 169px);
  }
  .float-tabs {
    position: absolute;
    width: 180px;
    left: -200px;
    top: 0;
    .float-header {
      height: 40px;
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
      background: rgb(255, 255, 255);
      color: rgb(51, 51, 51);
      font-size: 14px;
      display: flex;
      align-items: center;
      padding-left: 11px;
      img {
        width: 15px;
        margin-right: 8px;
      }
    }
    .float-tab-list {
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
      background: rgb(248, 248, 248);
      font-size: 14px;
      line-height: 40px;
      color: #878787;
      padding: 8px 0 11px 43px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 2px;
        top: 26px;
        left: 25.5px;
        background: rgb(227, 226, 226);
      }
      .float-tab-item {
        position: relative;
        span {
          cursor: pointer;
        }
        &:before {
          content: "";
          position: absolute;
          width: 7px;
          height: 7px;
          background: rgb(153, 153, 153);
          top: 17px;
          left: -20px;
          border-radius: 50%;
        }
        &.is-active {
          color: #CA4300;
          &:before {
            background: #CA4300;
          }
        }
      }
    }
  }
  .copy-btn {
    font-size: 12px;
    font-weight: 400;
    color: #ca4300;
    border: 1px solid #ca4300;
    padding: 2px;
    border-radius: 5px;
    cursor: pointer;
  }
  .redColor {
    color: #ca4303;
  }
  .member-tips {
    font-size: 14px;
    font-weight: 400;
    color: #878787;
    line-height: 22px;
    padding-left: 41px;
  }

  .btns {
    margin: 0 0 20px;
    padding-top: 8px;
    text-align: center;
    position: relative;
    .el-button {
      width: 180px;
      height: 44px;
      &:not(:last-child) {
        margin-right: 35px;
      }
    }
    .check-box {
      position: absolute;
      right: 26px;
      font-size: 14px;
      top: 12px;
    }
  }

  .staging-btn {
    border: 1px solid #AFAFAF;
    color: #333333;
  }

  .invoice-module {

    .edit-btn {
      margin-left: 20px;
      color: #CA4300;
      cursor: pointer;
    }
  }

  .invoice-btn {
    width: 142px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CA4300;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #CA4300;
    line-height: 34px;
    cursor: pointer;
    background: rgba(255, 102, 0, 0.05);
  }

  .invoice-item {
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    display: flex;

    .label {
      text-align: right;
      width: 165px;
      padding-right: 12px;
      flex-shrink: 0;
    }
  }

  .edit-address-btn {
    margin-left: 20px;
    color: #CA4300;
    cursor: pointer;
  }
  .address-content {
    display: flex;
    align-items: flex-start;

    .address-label {
      width: 220px;
      height: 34px;
      background: #FFFFFF;
      border: 2px solid #CA4300;
      position: relative;
      text-align: center;
      line-height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-shrink: 0;

      img {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      margin-right: 36px;
    }

    .address-detail {
      font-size: 14px;
      color: #333333;
      line-height: 34px;
    }


  }

  .memo-label {
    font-size: 14px;
    color: #333333;
    line-height: 1;
    margin-bottom: 11px;
  }

  .memo-textarea {
    margin-bottom: 14px;
  }

  .memo-textarea .el-textarea__inner {
    height: 60px;
    padding: 14px 15px;
  }

  .test-module {
    padding-bottom: 30px;

    .el-checkbox__label {
      font-size: 14px;
      color: #333333;
    }
  }
  .item-table {

  }

  .order-info {
    max-width: 1226px;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .apply-info,
  .report-info {
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    width: 49%;
    max-width: 601px;
    padding: 28px 41px 13px 0;

    .module-label {
      margin-left: 25px;
    }

    .copy-btn {
      width: 90px;
      height: 24px;
      background: #FFFFFF;
      border: 1px solid #CA4300;
      border-radius: 4px;
      font-size: 12px;
      color: #CA4300;
      line-height: 22px;
      padding: 0;
      margin-left: 30px;
      position: absolute;
      top: -4px;
      left: 100px;
    }
  }

  .file-list {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 30px;

    a {
      text-decoration: underline;
      color: #CA4300;
    }

    .del-file {
      cursor: pointer;
      margin-left: 20px;
      color: #878787;
    }
  }

  .reportEmail {
    ::v-deep .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input {
      width: 250px;
      margin-right: 16px;
    }

    .add-email,
    .cancel-add {
      width: 60px;
      height: 36px;
      font-size: 14px;
      line-height: 34px;
      padding: 0;
    }

    .cancel-add {}

    .add-email-input {
      position: relative;
      display: inline-block;

      .err-msg {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
      }
    }

    .email-item {
      font-size: 14px;
      color: #333333;
      line-height: 40px;
      margin-right: 20px;
    }

    .del-email {
      color: #878787;
      margin-left: 20px;
    }
  }

  .spec-tips {
    font-size: 14px;
    font-weight: 400;
    color: #878787;
    line-height: 22px;
    padding-bottom: 30px;
  }

  .notice {
    text-align: center;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    margin: 20px 0;
  }

  .report-content {
    padding-top: 29px;
    .report-list-tips {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 1px;
      margin-bottom: 40px;
    }
    .download-report-btn {
      color: #ca4300;
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        color: red;
      }
    }
    .report-item {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ca4300;
      line-height: 14px;
      margin-bottom: 30px;
      a {
        color: #ca4303;
      }
      .file {
        cursor: pointer;
      }
      &:hover {
        color: red;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .icon {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #535353;
        border-radius: 50%;
        margin-right: 13px;
        position: relative;
        top: -3px;
      }
    }
  }
}
.oiq-create-form {
  .reportTitleType {
    margin-bottom: 1px;
    &.is-error {
      margin-bottom: 10px;
    }
    .el-form-item__error {
      top: 29px;
    }
  }
  .yangpin-tab p {
    line-height: 20px;
  }
  td.yangpin-cell .cell {
    padding: 0;
    display: flex;
    justify-content: center;
  }
  .divider {
    width: 100%;
    border-bottom: 1px dashed rgb(210, 210, 210);
    margin-bottom: 24px;
  }
  .item-tips {
    width: 16px;
    height: 16px;
    position: absolute;
    right: -27px;
    top: 13px;
    cursor: pointer;
  }
}
.company-popper {
  min-width: 1000px !important;

  .autocomplete-item {
    display: flex;
    justify-content: space-between;

    span {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
    }

    .autocomplete-item-name {
      width: 250px;
    }

    .autocomplete-item-address {
      width: 490px;
    }

    .autocomplete-item-org,
    .autocomplete-item-date {
      width: 130px;
    }
  }
}

.invoice-tips {
  height: 140px;
  padding: 10px 0 0 0;

  .tips {
    color: #ca4300;
    background: rgba(255, 102, 0, 0.1);
    padding: 8px 14px;
  }
}

.invoice-popper.el-autocomplete-suggestion:not(.is-loading) {
  li:nth-child(odd) {
    background-color: #F3F3F3;
  }

  li:hover {
    background-color: #eef3fb;
  }
}

.oiq-create-form {
  .copy-checkbox {
    margin-left: 30px;
    color: #333333;

    .el-checkbox__inner {
      border-color: #ca4303;
    }
  }

  * {
    box-sizing: border-box;
  }

  .cs-form {

    .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      display: none;
    }

    .lab-item.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
    .lab-item.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      display: inline-block;
    }
  }

  .common-btn {
    height: 36px;
    background: rgba(255, 102, 0, 0.05);
    border: 1px solid #CA4300;
    border-radius: 4px;
    font-size: 14px;
    color: #CA4300;
    line-height: 34px;
    padding: 0 17px;
    cursor: pointer;
    display: inline-block;
    &.is-disabled {
      color: #C0C4CC;
      cursor: not-allowed;
      background-image: none;
      background-color: #FFF;
      border-color: #EBEEF5;
    }
  }

  .test-module {
    .el-checkbox__label {
      font-size: 14px;
      color: #333333;
    }

    .el-checkbox__inner {
      border: 1px solid #AFAFAF;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #CA4300;
    }

    .el-table {
      margin-bottom: 19px;
      border-color: #D2D2D2;
    }

    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: #D2D2D2 !important;
    }

    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #D2D2D2 !important;
    }

    .el-table--border th.el-table__cell,
    .el-table__fixed-right-patch {
      border-bottom: 1px solid #D2D2D2;
    }

    .el-table--border .el-table__cell,
    .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
      border-right: 1px solid #D2D2D2;
    }

    .el-table th,
    .el-table td {
      padding: 0;
    }

    .el-table th .cell {
      line-height: 38px;
      height: 38px;
      background: #F5F5F5;
      font-size: 12px;
      font-weight: bold;
    }

    .el-table td .cell {
      padding: 0;
    }

    .el-table .index-cell {
      padding: 0;
      text-align: center;
    }

    .el-table .el-input__inner {
      border: none;
    }

    .el-table--enable-row-hover .el-table__body tr:hover>td {
      background: #fff !important;
    }
  }

  .el-textarea__inner {

  }

  .item-table .el-textarea__inner {
    border: none;
  }

  .other_report .el-textarea__inner {
    height: 60px;
    padding: 14px 15px;
  }

  .no-error.el-form-item .el-form-item__error {
    display: none;
  }

  .module {
    max-width: 1226px;
    margin: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    padding: 23px 26px 0 26px;
    margin-bottom: 26px;
  }

  .module-label {
    padding: 0 15px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin-bottom: 24px;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 3px;
      height: 16px;
      background: #CA4300;
    }

    .tips {
      font-size: 14px;
      color: #CA4300;
      line-height: 16px;
      margin-left: 20px;
      font-weight: normal;
    }
  }

  .el-input__inner {
    border: 1px solid #D6D6D6;
  }

  .el-form-item__label {
    color: #333333;
    font-weight: normal;
    font-size: 14px;
  }
  .itemName-form-item.el-form-item {
    margin-bottom: 0;
    &.is-error {
      margin-bottom: 20px;
    }
    .el-form-item__error {
      padding-left: 30px;
    }
  }
  .text-item.el-form-item {
    .el-form-item__label, .el-form-item__content {
      line-height: 1;
    }
  }
}
</style>